import YouTube from './video/youtube';
import Vimeo from './video/vimeo';

$(() => {
  $('iframe[id^=vimeo]').each((index, el) => {
    // Set mutation observer
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          const video = new Vimeo(el);
          video.init();
        }
      });
    });

    // Try initiating
    if (el.hasAttribute('src')) {
      const video = new Vimeo(el);
      video.init();
    }

    observer.observe(el, {
      attributes: true,
    });
  });
});

window.onYouTubeIframeAPIReady = () => {
  $('iframe[id^=yt]').each((index, el) => {
    const video = new YouTube(el);
    video.init();
  });
};
